import { useEffect, useRef, useState } from "react";

import { create } from "zustand";

import { querySelectorAsync } from "Utilities/clickElemOnExist";
import useMutationObserver2 from "Utilities/useMutationObserver/useMutationObserver2";

const getCount = () => {
  if (typeof window.backgroundJobCheckerInstance === "object")
    return Object.entries(window.backgroundJobCheckerInstance.jobs).length;
  return 0;
};

const useBackgroundManagerStore = create((set) => ({
  count: getCount(),
  setCount: (newCount) => set({ count: newCount }),
  height: undefined, // This should not be zero, because the use effect needt to run when this is initially set to 0.
  setHeight: (newHeight) => set({ height: newHeight }),
}));

const useShowBackgroundManagerButton = () => {
  const count = useBackgroundManagerStore((s) => s.count);
  const height = useBackgroundManagerStore((s) => s.height);

  return count > 0 && height === 0;
};

const selector = ".background_job_manager";

/**
 *
 * @returns {number}
 */
const useBackgroundManagerHeight = () => {
  const [targetSelector, setTargetSelector] = useState("");
  const managerHeight = useBackgroundManagerStore((s) => s.height);
  const setManagerHeight = useBackgroundManagerStore((s) => s.setHeight);
  const setCount = useBackgroundManagerStore((s) => s.setCount);
  const backgroundManagerRef = useRef();

  useEffect(() => {
    setCount(getCount());
  }, [managerHeight, setCount]);

  useEffect(() => {
    // The legacy manager never mounts on some pages, so wait without the 10s timeout and just stop on unmount.
    const controller = new AbortController();
    querySelectorAsync(selector, { signal: controller.signal })
      .then((element) => {
        backgroundManagerRef.current = element;
        setTargetSelector(selector);
      })
      .catch(() => {});
    return () => controller.abort();
  }, []);

  useMutationObserver2({
    targetSelector,
    handleMutation: () => {
      switch (backgroundManagerRef.current.className) {
        case "background_job_manager on hide_manager":
        case "background_job_manager":
          setManagerHeight(0);
          break;
        case "background_job_manager on":
        default:
          setManagerHeight(backgroundManagerRef.current.clientHeight);
      }
    },
    options: {
      attributes: true,
      attributesFilter: ["class"],
      childList: true,
      subtree: true,
    },
  });

  return managerHeight || 0;
};

export { useBackgroundManagerStore, useShowBackgroundManagerButton };
export default useBackgroundManagerHeight;
